import { render, staticRenderFns } from "./identityCard.vue?vue&type=template&id=79648eb9&"
import script from "./identityCard.vue?vue&type=script&lang=js&"
export * from "./identityCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports